import React, { useContext, useEffect, useMemo, useState } from 'react';
import { ErrorContext } from "../../../components/GympinPagesProvider";
import Slick from "react-slick";
import { Box, Skeleton, Typography } from "@mui/material";
import { LocalFireDepartmentRounded } from "@mui/icons-material";
import { getListByViewType, getQueryResults } from "./_ep_queries";

const _ep_CAROUSEL_INCREDIBLE_LIST = ({ carousel }) => {
    const error = useContext(ErrorContext);
    const isStatic = !carousel?.Items?.[0]?.Type?.startsWith("QUERY");
    const [items, setItems] = useState(() => isStatic ? carousel?.Items : null);
    const itemType = carousel?.Items?.[0]?.ViewType;
    const carouselId = carousel?.Id || carousel?.Description;

    useEffect(() => {
        if (!carousel) return;
        if (isStatic && carousel?.Items) {
            setItems(carousel.Items);
            return;
        }

        let isMounted = true;
        getQueryResults(carousel, error)
            .then(result => {
                if (isMounted) setItems(result);
            })
            .catch(e => {
                console.error("Incredible list query error:", e);
            });

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carouselId, isStatic]);

    const slickSettings = useMemo(() => {
        let parsed = {};
        try {
            if (carousel?.Data) {
                parsed = typeof carousel.Data === "object" ? carousel.Data : JSON.parse(carousel.Data);
            }
        } catch {
            parsed = {};
        }

        return {
            rtl: true,
            swipeToSlide: true,
            arrows: false,
            dots: false,
            ...parsed
        };
    }, [carousel?.Data]);

    const displayItems = useMemo(() => {
        if (!items || !items.length) return [];
        if (items.length >= 4) return items;
        let list = items;
        while (list.length < 4) {
            list = [...list, ...items];
        }
        return list.slice(0, 4);
    }, [items]);

    if (!items) {
        return (
            <Box sx={{ px: { xs: 1.5, sm: 2 }, my: 3 }}>
                <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={260}
                    sx={{ width: "100%", borderRadius: "24px" }}
                />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                background: "linear-gradient(135deg, #e7333e 0%, #b22831 60%, #911212 100%)",
                py: { xs: 2.5, sm: 3 },
                my: { xs: 3, sm: 4 },
                mx: { xs: 1, sm: 2 },
                borderRadius: { xs: "20px", sm: "24px" },
                boxShadow: "0 16px 36px -8px rgba(231, 51, 62, 0.35)",
                position: "relative",
                overflow: "hidden"
            }}
        >
            {/* هدر بخش شگفت‌انگیز */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: { xs: 2, sm: 2.5 },
                    mb: 1.5
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                    <Box
                        sx={{
                            width: 38,
                            height: 38,
                            borderRadius: "12px",
                            bgcolor: "rgba(255, 255, 255, 0.2)",
                            backdropFilter: "blur(8px)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
                        }}
                    >
                        <LocalFireDepartmentRounded sx={{ fontSize: 24, color: "#fbbf24" }} />
                    </Box>
                    <Box>
                        <Typography
                            variant="h6"
                            component="h2"
                            sx={{
                                fontWeight: 900,
                                fontSize: { xs: "1.1rem", sm: "1.25rem" },
                                color: "#ffffff",
                                letterSpacing: "-0.3px",
                                lineHeight: 1.2
                            }}
                        >
                            {carousel?.Description || "پیشنهادهای شگفت‌انگیز"}
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                color: "rgba(255, 255, 255, 0.8)",
                                fontSize: "0.72rem",
                                fontWeight: 600
                            }}
                        >
                            تخفیف‌های ویژه و فرصت محدود
                        </Typography>
                    </Box>
                </Box>

                {/* نشان فرصت محدود */}
                <Box
                    sx={{
                        bgcolor: "rgba(255, 255, 255, 0.18)",
                        backdropFilter: "blur(6px)",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                        color: "#ffffff",
                        px: 1.25,
                        py: 0.4,
                        borderRadius: "10px",
                        fontSize: "0.75rem",
                        fontWeight: 800,
                        letterSpacing: "-0.2px"
                    }}
                >
                    ویژه امروز
                </Box>
            </Box>

            {/* اسلایدر کارت‌های شگفت‌انگیز */}
            <Box sx={{ px: { xs: 0.5, sm: 1 }, overflow: "hidden" }} dir="rtl">
                <Slick {...slickSettings}>
                    {displayItems.map((item, index) => getListByViewType(itemType, item, index))}
                </Slick>
            </Box>
        </Box>
    );
};

export default React.memo(_ep_CAROUSEL_INCREDIBLE_LIST);

